import { BookOpenTextIcon, CalendarCheckIcon, CalendarXIcon, ClipboardCheckIcon, DicesIcon, FileTextIcon, FolderSearchIcon, LayoutGridIcon, LightbulbIcon, PencilRulerIcon, ShapesIcon, ShuffleIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
export const PRODUCT_IMAGE = 'https://sb.impultienda.ar/storage/v1/object/public/store-resources/cc86d158-9389-4aaf-80f6-6397c11ce81f/1793816914005_caja-transp-0e7fc86c.webp';
export const heroGuarantees = ['Natychmiastowy dostęp cyfrowy', 'Jednorazowa płatność', 'Bez abonamentu', '7 dni gwarancji satysfakcji'];
export const stats = [{
  value: '240',
  label: 'Stron w sześciu tomach'
}, {
  value: '6',
  label: 'Cyfrowych tomów aqua aerobiku'
}, {
  value: '3',
  label: 'Grupy – łagodna, intensywna i aqua cycling'
}, {
  value: '5',
  label: 'Bonusów w cenie'
}, {
  value: '1',
  label: 'Kompletny system na basen'
}];
export const differenceStats = [{
  value: '3 grupy',
  label: 'Od łagodnego aqua aerobiku po aqua cycling, na trzech poziomach'
}, {
  value: '6 tomów cyfrowych',
  label: 'Od planu sezonu po odznaki postępów'
}, {
  value: 'PDF do druku',
  label: 'Na tablecie albo wydrukowane – prosto na brzeg basenu'
}];
export const beforeItems: Array<{
  title: string;
  text: string;
}> = [{
  title: 'Niedzielne wieczory znikają',
  text: 'Godziny przy komputerze nad zajęciami na cały tydzień – i wciąż nie jest gotowe.'
}, {
  title: 'Godziny szukania',
  text: 'Ćwiczenia z internetu są za proste, za trudne albo nie pasują do Twojej grupy.'
}, {
  title: 'Każde zajęcia od zera',
  text: 'Rozgrzewka, ruchy podstawowe, część główna, zabawa grupowa, wyciszenie – coś, co powinno zająć minuty, zamienia się w osobną pracę.'
}, {
  title: 'Trudno pracować z różnymi poziomami',
  text: 'Początkujący i stali bywalcy w tym samym basenie: ktoś zawsze się nudzi.'
}, {
  title: 'Śledzenie postępów i organizacja zajmują czas',
  text: 'Listy obecności, odznaki, wiadomości do uczestników: kolejna praca po zajęciach.'
}, {
  title: 'Stres przed zajęciami',
  text: 'Gdy brakuje czasu, improwizujesz i składasz zajęcia w ostatniej chwili na brzegu basenu.'
}];
export const afterItems = ['Uporządkowany pakiet aqua aerobiku dla dorosłych w każdym wieku', 'Zajęcia minuta po minucie, łatwe do poprowadzenia', 'Karty zajęć gotowe do druku od razu', '100 gotowych ćwiczeń aqua aerobiku i aqua cyclingu', 'Ruchy krok po kroku i odznaki postępów', '3 poziomy w tym samym basenie', 'Jasne zasady bezpieczeństwa na brzegu basenu', 'Gotowe karty śledzenia postępów', 'Plan na cały sezon'];
export const recognizeItems: Array<{
  icon: LucideIcon;
  title: string;
  text: string;
}> = [{
  icon: CalendarXIcon,
  title: 'Weekendy na przygotowaniach',
  text: 'Czy spędzasz część weekendu na przygotowywaniu zajęć na kolejny tydzień?'
}, {
  icon: FolderSearchIcon,
  title: 'Nie wiesz, jakie ćwiczenie wybrać',
  text: 'Czy ciągle szukasz ruchów dopasowanych do poziomu Twoich uczestników?'
}, {
  icon: LightbulbIcon,
  title: 'Chcesz jaśniej tłumaczyć',
  text: 'Czy potrzebujesz materiałów wizualnych, żeby prosto pokazać ruch z brzegu basenu?'
}, {
  icon: PencilRulerIcon,
  title: 'Chcesz przestać tworzyć wszystko od zera',
  text: 'Czy chcesz, żeby zajęcia, ćwiczenia i karty były już gotowe?'
}, {
  icon: ShuffleIcon,
  title: 'Uczestnicy potrzebują różnorodności',
  text: 'Czy chcesz mieć więcej choreografii, zabaw i stacji, żeby utrzymać motywację grupy?'
}, {
  icon: LayoutGridIcon,
  title: 'Potrzebujesz jasnej struktury',
  text: 'Czy chcesz mieć wszystkie materiały w jednym miejscu i szybko znaleźć to, czego potrzebujesz?'
}];

// Spine colours mirror the physical box (blue, light blue, green, yellow, orange, red).
export const volumes: Array<{
  number: string;
  level: string;
  title: string;
  tagline: string;
  intro: string;
  items: string[];
  outro: string;
  note?: string;
  spine: string;
  rule: string;
}> = [{
  number: 'Tom 01',
  level: 'Poziomy 1–3',
  title: 'Plan sezonu i 12 zajęć minuta po minucie',
  tagline: 'Cały sezon rozpisany, miesiąc po miesiącu.',
  intro: 'Pierwszy tom daje plan sezonu dla trzech grup i 12 kompletnych zajęć minuta po minucie.',
  items: ['Plan: łagodny aqua aerobik i seniorzy, intensywny aqua aerobik, aqua cycling', 'Tydzień przy 1, 2 lub 3 zajęciach', 'Struktura zajęć 30 i 45 minut', '3 poziomy w tym samym basenie', '12 zajęć minuta po minucie', 'Karty zajęć do druku', 'Plan basenu i stacje', 'Bezpieczeństwo i lista kontrolna', 'Karta śledzenia postępów grupy'],
  outro: 'Wchodzisz na basen, wiedząc dokładnie, co robić.',
  spine: 'bg-blue-700 text-white',
  rule: 'border-white/30'
}, {
  number: 'Tom 02',
  level: 'Poziomy 1–3',
  title: 'Bank zajęć: 50 gotowych zajęć',
  tagline: 'Gotowe zajęcia na każdą sytuację.',
  intro: 'Drugi tom to 50 gotowych zajęć, uporządkowanych według tematu i grupy.',
  items: ['Struktury 30 i 45 minut', '8 zajęć łagodnego aqua aerobiku i dla seniorów', 'Mobilność i równowaga', 'Łagodne cardio i rytm', 'Wzmacnianie ogólne ze sprzętem', 'Aqua cycling i obwody w wodzie', 'Przed dniem odznak', 'Zajęcia próbne w głębokiej wodzie', 'Zajęcia w parach'],
  outro: 'Wybierasz, drukujesz, prowadzisz.',
  spine: 'bg-sky-500 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Tom 03',
  level: 'Poziomy 1–3',
  title: '100 ćwiczeń aqua aerobiku i aqua cyclingu',
  tagline: 'Uczestnicy, którzy się ruszają, uśmiechają i wracają.',
  intro: 'Trzeci tom zawiera 100 ćwiczeń uporządkowanych według celu i grupy, z wariantami i zasadami bezpieczeństwa.',
  items: ['Rozgrzewka w wodzie', 'Ruchy bez sprzętu', 'Ćwiczenia z makaronami i deskami', 'Hantle piankowe, rękawiczki z błoną i stepy', 'Ćwiczenia na rowerze wodnym', 'Ćwiczenia dla grupy łagodnej i seniorów', 'Zabawy grupowe', 'Wyciszenie', 'Własna choreografia'],
  outro: 'Radość z aqua aerobiku, bez przygotowań.',
  spine: 'bg-green-600 text-white',
  rule: 'border-white/30'
}, {
  number: 'Tom 04',
  level: 'Poziomy 1–3',
  title: 'Ruchy krok po kroku, muzyka i odznaki postępów',
  tagline: 'Każdy ruch wyjaśniony prosto.',
  intro: 'Czwarty tom pokazuje ruchy krok po kroku, muzykę w BPM i odznaki postępów.',
  items: ['Marsz w wodzie i przemieszczanie się', 'Ruchy ramion pod wodą', 'Ustawienie roweru wodnego i pozycje', 'Muzyka i tempo wodne', 'Choreografie', 'Odznaki postępów', 'Karty ruchów do druku', 'Częste błędy i poprawki'],
  outro: 'Jasne ruchy, dopasowane do każdego poziomu.',
  spine: 'bg-yellow-400 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Tom 05',
  level: 'Poziomy 1–3',
  title: 'Bezpieczeństwo, prowadzenie grupy i uczestnicy',
  tagline: 'Spokojna grupa, lojalni uczestnicy.',
  intro: 'Piąty tom pomaga dbać o bezpieczeństwo na basenie, prowadzić grupę i budować relację z uczestnikami.',
  items: ['Zasady bezpieczeństwa na basenie', 'Oznaki złego samopoczucia i co robić', 'Prowadzenie grupy i rytuały', 'Uczestnicy niepewni lub początkujący', 'Komunikacja z uczestnikami', 'Zapisy, karnet i karta Multisport', 'Organizacja sezonu', 'Listy kontrolne'],
  outro: 'Więcej spokoju, zajęcia po zajęciach.',
  spine: 'bg-orange-500 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Tom 06',
  level: 'Poziomy 1–3',
  title: 'Postępy, zajęcia tematyczne i zakończenie sezonu',
  tagline: 'Widzisz postępy każdego uczestnika.',
  intro: 'Szósty tom zawiera punkty odniesienia postępów, zajęcia tematyczne i wszystko, czego potrzebujesz na udane zakończenie sezonu.',
  items: ['Karty śledzenia postępów', 'Swoboda w wodzie i mobilność', 'Arkusze obserwacji', 'Dzień odznak', 'Zajęcia tematyczne', 'Dyplomy', 'Podsumowanie sezonu', 'Śledzenie postępów grupy'],
  outro: 'Widoczne postępy dla uczestników i dla pływalni.',
  note: 'Materiał nie zastępuje szkolenia ani nadzoru ratownika na pływalni.',
  spine: 'bg-red-600 text-white',
  rule: 'border-white/30'
}];
export const volumesIntro = {
  title: '6 cyfrowych tomów dla Twoich grup',
  text: 'Kompletny pakiet aqua aerobiku i aqua cyclingu, który pomaga przygotować i poprowadzić zajęcia przez cały sezon. Każdy tom ma 40 stron zajęć, ćwiczeń, kart i aktywności na basen.'
};
export const packItems: Array<{
  icon: LucideIcon;
  title: string;
  text: string;
}> = [{
  icon: BookOpenTextIcon,
  title: 'Gotowe zajęcia',
  text: 'Koniec z pustą kartką. Zajęcia minuta po minucie ze słowami instruktora – możesz zacząć od razu.'
}, {
  icon: FileTextIcon,
  title: 'Karty do druku',
  text: 'Karty zajęć, plakaty i karty śledzenia postępów do wydrukowania i zabrania na brzeg basenu.'
}, {
  icon: ShapesIcon,
  title: 'Ruchy w obrazkach',
  text: 'Plany basenu, ilustrowane etapy i proste komendy, które pomagają wytłumaczyć każdy ruch.'
}, {
  icon: DicesIcon,
  title: 'Ćwiczenia i zabawy',
  text: '100 ćwiczeń na rozgrzewkę, ruch całej grupy i zajęcia ze sprzętem lub bez – bezpiecznie.'
}, {
  icon: ClipboardCheckIcon,
  title: 'Postępy i odznaki',
  text: 'Arkusze obserwacji, punkty odniesienia postępów i gotowe odznaki.'
}, {
  icon: CalendarCheckIcon,
  title: 'Plan sezonu',
  text: 'Od września do czerwca: każdy miesiąc ma swój temat, cele i wydarzenia.'
}];
export const pageSamples: Array<{src: string; label: string; title: string; text: string}> = [
  {
    "src": "https://sb.impultienda.ar/storage/v1/object/public/store-resources/cc86d158-9389-4aaf-80f6-6397c11ce81f/1793816942201_t1-p01-68ab795e.webp",
    "label": "Tom 01 · Strona 1",
    "title": "Okładka",
    "text": "Plan sezonu i 12 zajęć minuta po minucie."
  },
  {
    "src": "https://sb.impultienda.ar/storage/v1/object/public/store-resources/cc86d158-9389-4aaf-80f6-6397c11ce81f/1793816949340_t1-p04-497928c0.webp",
    "label": "Plan sezonu · Strona 4",
    "title": "Łagodny aqua aerobik i seniorzy",
    "text": "Plan sezonu miesiąc po miesiącu, z celami i wydarzeniami w płytkiej wodzie."
  },
  {
    "src": "https://sb.impultienda.ar/storage/v1/object/public/store-resources/cc86d158-9389-4aaf-80f6-6397c11ce81f/1793816956016_t1-p11-8d46db36.webp",
    "label": "Karta zajęć · Strona 11",
    "title": "Karta zajęć 1",
    "text": "Czasy części zajęć, schemat basenu, 3 poziomy i bezpieczeństwo na jednej stronie."
  },
  {
    "src": "https://sb.impultienda.ar/storage/v1/object/public/store-resources/cc86d158-9389-4aaf-80f6-6397c11ce81f/1793816963225_t1-p21-dbf93216.webp",
    "label": "Karta zajęć · Strona 21",
    "title": "Karta zajęć 6",
    "text": "Schemat basenu, słowa-klucze i 3 poziomy skoków, gotowe do druku."
  },
  {
    "src": "https://sb.impultienda.ar/storage/v1/object/public/store-resources/cc86d158-9389-4aaf-80f6-6397c11ce81f/1793816970662_t1-p34-c62315e3.webp",
    "label": "Stacje · Strona 34",
    "title": 'Plan basenu i stacje',
    "text": "Stacje w tym samym basenie: rowery wodne, stepy wodne, makarony i hantle."
  }
];
export const pageTypes = ['Gotowe zajęcia', 'Karty do druku', 'Ćwiczenia i stacje', 'Postępy i odznaki'];
export const bonuses: Array<{
  title: string;
  text: string;
  items: string[];
  benefit: string;
}> = [{
  title: 'Zastępstwa bez stresu – 12 gotowych zajęć dla zastępcy',
  text: 'Grupa ćwiczy dalej, nawet gdy nie możesz przyjść.',
  items: ['Karta przekazania zajęć', '12 gotowych zajęć', '4 dla każdej grupy', 'Lista obecności'],
  benefit: 'Możesz być spokojny – zajęcia się odbędą.'
}, {
  title: 'Rozgrzewki w 5 minut – 60 kart',
  text: '60 kart aqua aerobiku do druku, żeby ułożyć rozgrzewkę w pięć minut.',
  items: ['Marsz i przemieszczanie się w wodzie', 'Mobilność barków i ramion', 'Mobilność bioder i równowaga', '5 gotowych rozgrzewek'],
  benefit: 'Inna rozgrzewka na każdych zajęciach.'
}, {
  title: 'Zajęcia tematyczne i święto aqua aerobiku',
  text: 'Wszystko, czego potrzebujesz, żeby zorganizować zajęcia tematyczne i święto na zakończenie sezonu bez chaosu.',
  items: ['Plan na 6 tygodni', '10 zajęć tematycznych', 'Dyplomy do druku', 'Zajęcia „przyprowadź znajomego”'],
  benefit: 'Udane wydarzenie, bez stresu.'
}, {
  title: 'Komunikacja z uczestnikami – 40 wiadomości',
  text: 'Gotowe wiadomości na cały sezon: kopiujesz i wysyłasz.',
  items: ['Zapisy, karnet i karta Multisport', 'Start sezonu i godziny zajęć', 'Zajęcia odwołane lub przeniesione', 'Spotkanie powitalne i najczęstsze pytania'],
  benefit: 'Poinformowani i lojalni uczestnicy.'
}, {
  title: 'Plakaty na basen – 15 plakatów',
  text: 'Kolorowe plakaty, które porządkują zajęcia i witają uczestników.',
  items: ['Zasady na basenie', 'Ustawienie roweru wodnego', 'Sygnały instruktora', 'Każdy w swoim tempie'],
  benefit: 'Basen, który informuje, nawet gdy mówisz.'
}];
export const steps: Array<{
  title: string;
  text: string;
}> = [{
  title: 'Otwórz AQUAAEROBIK GOTOWY™',
  text: 'Pobierz pakiet i otwórz tom, który pasuje do Twojej grupy.'
}, {
  title: 'Wybierz zajęcia',
  text: 'Znajdź miesiąc i temat, a potem wybierz zajęcia, ćwiczenie albo kartę, która pasuje do Twoich uczestników.'
}, {
  title: 'Przygotuj się w 5 minut',
  text: 'Przeczytaj przebieg zajęć i przygotuj potrzebny sprzęt i muzykę.'
}, {
  title: 'Wydrukuj i idź na basen',
  text: 'Wydrukuj kartę zajęć albo otwórz ją na tablecie – i zacznij z jasnym planem.'
}];
export const audienceItems = ['Prowadzisz łagodny aqua aerobik, intensywny aqua aerobik albo aqua cycling', 'Chcesz mieć uporządkowany cały sezon aqua aerobiku', 'Chcesz przestać przygotowywać każde zajęcia od zera', 'Masz różne poziomy w tym samym basenie', 'Szukasz bezpiecznych i różnorodnych ćwiczeń', 'Chcesz mieć gotowe karty postępów i odznaki', 'Chcesz oszczędzać czas co tydzień', 'Chcesz czuć się przygotowany przed każdymi zajęciami'];
export const timeValueTasks = ['Szukanie ćwiczeń', 'Pisanie przebiegu zajęć', 'Przygotowanie stacji, sprzętu i muzyki', 'Organizacja grup i poziomów', 'Śledzenie postępów i wiadomości do uczestników'];
export const offerRows: Array<{
  label: string;
  detail: string;
}> = [{
  label: '6 cyfrowych tomów – 240 stron',
  detail: 'Plan sezonu, zajęcia, ćwiczenia, ruchy, bezpieczeństwo i śledzenie postępów'
}, {
  label: '5 bonusów bez dodatkowych kosztów',
  detail: 'Zastępstwa, rozgrzewki, zajęcia tematyczne, wiadomości do uczestników i plakaty'
}, {
  label: 'Łagodny aqua aerobik, intensywny aqua aerobik i aqua cycling',
  detail: 'Gotowe zajęcia, karty do druku i śledzenie postępów'
}];
export const offerIncludes = ['Natychmiastowy dostęp cyfrowy', 'Pliki PDF do zachowania', 'Karty do druku', 'Nie wysyłamy produktu fizycznego'];
export const PRICE = '99 zł';
export const COMPARE_PRICE = '199 zł';

// Only add authentic reviews of AQUAAEROBIK GOTOWY. The section stays hidden while empty.
export const testimonials: Array<{
  quote: string;
  name: string;
  location: string;
}> = [];
export const faqs = [{
  q: 'Jak otrzymam materiał?',
  a: 'AQUAAEROBIK GOTOWY™ to produkt cyfrowy. Po zakupie otrzymasz dostęp do plików PDF, które możesz pobrać i zachować. Możesz korzystać z nich na komputerze, tablecie lub telefonie i drukować potrzebne karty.'
}, {
  q: 'Czy AQUAAEROBIK GOTOWY™ pasuje do polskich pływalni?',
  a: 'Tak. Materiał jest przygotowany dla instruktorów rekreacji ruchowej, ratowników WOPR prowadzących zajęcia oraz instruktorów aqua aerobiku i aqua cyclingu na pływalniach miejskich, w OSiR-ach, aquaparkach, klubach i hotelach: płytka i głęboka woda, godziny zajęć, karnet i karta Multisport, zapisy we wrześniu, ferie zimowe i wakacje. Materiał nie zastępuje szkolenia ani nadzoru ratownika na pływalni.'
}, {
  q: 'Czy pasuje do wszystkich moich grup?',
  a: 'Tak. Sześć tomów jest podzielonych na trzy grupy: łagodny aqua aerobik i seniorzy w płytkiej wodzie, intensywny aqua aerobik i aqua fitness, aqua cycling i obwody w wodzie. Wybierasz według uczestników i poziomu Twojej grupy.'
}, {
  q: 'Czy naprawdę przygotuję zajęcia w 5 minut?',
  a: 'AQUAAEROBIK GOTOWY™ jest zaprojektowany tak, żeby przyspieszyć przygotowanie. Otwierasz tom, wybierasz gotowe zajęcia i przeglądasz je w około pięć minut. Czas może się różnić w zależności od grupy i Twoich zmian.'
}, {
  q: 'Czy materiału wystarczy na cały sezon?',
  a: 'AQUAAEROBIK GOTOWY™ zawiera zajęcia i aktywności na cały sezon, od września do czerwca. Wybierasz, łączysz i dostosowujesz je do swojego planu i grupy.'
}, {
  q: 'Czy są karty gotowe do druku?',
  a: 'Tak. Pakiet zawiera karty zajęć, plakaty, karty śledzenia postępów i dyplomy do druku.'
}, {
  q: 'Czy ćwiczenia są bezpieczne dla moich uczestników?',
  a: 'Tak. Wejście do wody po schodkach, odpowiednia głębokość, przerwy na nawodnienie, zawsze możliwa wersja bez podskoków i jedna jasna zasada: zwiększamy zakres ruchu i opór wody, nigdy szybkość. Każde zajęcia mają ramkę bezpieczeństwa.'
}, {
  q: 'Czy mogę pracować z grupą o różnym poziomie?',
  a: 'Tak. Każde zajęcia mają 3 poziomy, żeby początkujący i stali bywalcy ćwiczyli razem w tym samym basenie.'
}, {
  q: 'Czy muszę wszystko drukować?',
  a: 'Nie. Drukujesz tylko te strony, których potrzebujesz, a resztę możesz wyświetlać na tablecie.'
}, {
  q: 'Czy pięć bonusów jest w cenie?',
  a: `Tak. Wszystkie pięć bonusów jest w pakiecie bez dodatkowych kosztów – całość za ${PRICE}.`
}, {
  q: 'Czy to abonament?',
  a: 'Nie. Płacisz jeden raz i otrzymujesz dostęp do materiałów cyfrowych. Bez żadnych cyklicznych opłat.'
}, {
  q: 'Czy mogę zachować pliki?',
  a: 'Tak. Możesz pobrać i zachować pliki PDF zgodnie z warunkami korzystania z produktu.'
}, {
  q: 'Czy mogę korzystać z telefonu lub tabletu?',
  a: 'Tak. Pliki PDF otworzysz na komputerze, tablecie i telefonie. Do sprawdzenia układu przed drukiem polecamy komputer lub tablet.'
}, {
  q: 'Czy jest gwarancja?',
  a: 'Tak. AQUAAEROBIK GOTOWY™ ma 7-dniową gwarancję satysfakcji. Jeśli materiał nie spełni Twoich oczekiwań, napisz do nas w okresie gwarancji i poproś o zwrot pieniędzy, zgodnie z warunkami.'
}];
export const footerLinks = ['Regulamin sprzedaży', 'Polityka prywatności', 'Polityka zwrotów', 'Kontakt'];